import axios from "axios";
import config from './config';
const TOKEN_KEY = 'token';
const INFO_KEY = "info";

const getToken = function() {
  //从配置文件中读取token 若没写入 则从storage中取并写入配置
  // if(config.dev) {
  //   return {
  //     token: '05ef10a0d04c00eb56629e0de74e435a'
  //   }
  // } else {
  //
  // }
  let token = config.token;
  if(!token) {
    console.log('Read token from storage.');
    token = getStorage(TOKEN_KEY);
    config.token = token;
  }
  //判断token是否过期 过期返回null
  if(token && Date.now() - token.timestamp > 59 * 60 * 1000) {
    token = null;
  }
  return token;
};

const setToken = function(token) {
  let temp = {
    timestamp: Date.now(),
    token: token.token,
    subscribe: token.subscribe
  };
  config.token = temp;
  let value = JSON.stringify(temp);
  localStorage.setItem(TOKEN_KEY, value);
};

const getStorage = function(key) {
  let result = null;
  let storage = localStorage.getItem(key);
  try {
    storage = JSON.parse(storage);
    result = storage;
  } catch (e) {
    console.log(`Storage for ${key} parse failed.`);
  }
  return result;
};

const cleanToken = function() {
  localStorage.removeItem(TOKEN_KEY);
  config.token = null;
};

const getInfo = function (fn, force) {
  let info = config.info || getStorage(INFO_KEY);
  if(info && !force) {
    config.info = info;
    typeof fn === 'function' && fn(config.info);
  } else {
    axios({
      url: '/user/i',
      method: 'GET'
    }).then(res => {
      config.info = res;
      localStorage.setItem(INFO_KEY, JSON.stringify(res));
      typeof fn === 'function' && fn(res);
    });
  }
}


export { getToken, getStorage, setToken, cleanToken, getInfo }
